angular.module('ApptBookApp').controller('AppointmentBookMenuController', [
    '$scope',
    '$http',
    '$rootScope',
    'appointmentBookModalService',
    'appointmentBookBuilderService',
    'appointmentBookGlobalsService',
    'opacityFilterSelections',
    'Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService',
    'meevo.components.common.IdentityService',
    'meevo.components.common.DataService',
    function(
        $scope,
        $http,
        $rootScope,
        modal,
        builder,
        globals,
        opacityFilterSelections,
        filterActions: Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService,
        identityService: Meevo.Components.Common.IIdentityService,
        dataService: Meevo.Components.Common.ICommonDataService
    ) {
        $scope.modal = modal;
        $scope.isEmployeeView = globals.isEmployeeView;
        $scope.currentIdentity = identityService.current();
        $scope.meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
        let loggedInUser = null;
        dataService.getItem('employee', $scope.currentIdentity.userId).then((response: Meevo.Model.Employee) => {
            loggedInUser = response;
            if (!loggedInUser.employeeCode) {
                loggedInUser.displayName = loggedInUser.userName;
            }
        });

        $scope.statusFilters = [
            { value: "AllServices", label: "", text: "", appointmentTransitionStateEnum: [], appointmentFinalStateEnum: [] },
            { value: "ServicesCheckedIn", label: "LABEL_CHECKED_IN", text: "LABEL_CHECKED_IN", appointmentTransitionStateEnum: [164], appointmentFinalStateEnum: [] },
            { value: "ServicesCheckedOut", label: "LABEL_CHECKED_OUT", text: "LABEL_CHECKED_OUT", appointmentTransitionStateEnum: [], appointmentFinalStateEnum: [2051] },
            { value: "NoShowServices", label: "LABEL_NO_SHOW", text: "LABEL_NO_SHOW", appointmentTransitionStateEnum: [166], appointmentFinalStateEnum: [] },
            { value: "ServicesRunningLate", label: "LABEL_RUNNING_LATE", text: "LABEL_RUNNING_LATE", appointmentTransitionStateEnum: [163], appointmentFinalStateEnum: [] },
            { value: "ServicesNotCheckedOut", label: "LABEL_NOT_CHECKED_OUT", text: "LABEL_NOT_CHECKED_OUT", appointmentTransitionStateEnum: [], appointmentFinalStateEnum: [2053]},
            { value: "ServicesNotCheckedIn", label: "LABEL_NOT_CHECKED_IN", text: "LABEL_NOT_CHECKED_IN", appointmentTransitionStateEnum: [163, 180, 195], appointmentFinalStateEnum: [2053]}
        ];

        $scope.confirmationStatusFilters = [
            { value: "AllStatuses", label: "", text: "", appointConfirmStateEnum: [] },
            { value: Meevo.Model.AppointConfirmStateEnum.RespondedReschedule, label: "", text: "LABEL_REQUESTED_RESCHEDULE", appointConfirmStateEnum: [Meevo.Model.AppointConfirmStateEnum.RespondedReschedule] },
            { value: Meevo.Model.AppointConfirmStateEnum.Unconfirmed, label: "", text: "LABEL_UNCONFIRMED", appointConfirmStateEnum: [Meevo.Model.AppointConfirmStateEnum.Unconfirmed] },
            { value: Meevo.Model.AppointConfirmStateEnum.UnableToContact, label: "", text: "LABEL_UNABLE_TO_CONTACT", appointConfirmStateEnum: [Meevo.Model.AppointConfirmStateEnum.UnableToContact] },
            { value: Meevo.Model.AppointConfirmStateEnum.LeftMessage, label: "", text: "LABEL_LEFT_MESSAGE", appointConfirmStateEnum: [Meevo.Model.AppointConfirmStateEnum.LeftMessage] },
            { value: Meevo.Model.AppointConfirmStateEnum.AwaitingResponse, label: "", text: "LABEL_AWAITING_RESPONSE", appointConfirmStateEnum: [Meevo.Model.AppointConfirmStateEnum.AwaitingResponse] },
            { value: Meevo.Model.AppointConfirmStateEnum.Confirmed, label: "", text: "LABEL_CONFIRMED", appointConfirmStateEnum: [Meevo.Model.AppointConfirmStateEnum.Confirmed] },
            { value: Meevo.Model.AppointConfirmStateEnum.DoNotConfirm, label: "", text: "LABEL_DO_NOT_CONFIRM", appointConfirmStateEnum: [Meevo.Model.AppointConfirmStateEnum.DoNotConfirm] }
        ];

        if (opacityFilterSelections) {
            opacityFilterSelections = $.extend(true, {}, opacityFilterSelections);
            opacityFilterSelections.appointStatusFilter = _.findWhere($scope.statusFilters, {value : opacityFilterSelections.appointStatusFilter.value});
            opacityFilterSelections.confirmStatusFilter = _.findWhere($scope.confirmationStatusFilters, { value: opacityFilterSelections.confirmStatusFilter.value });
            $scope.selections = opacityFilterSelections;
        } else {
            createDefault();
        }

        $scope.selectionChanged = function () {
            filterActions.includeFilterData = $scope.selections.isFirstTimeServiceCategoryBooked ||
                $scope.selections.isRepeatClientBusiness ||
                $scope.selections.isRepeatClientEmployee;

            globals.loadBookOnApplyFilter = filterActions.includeFilterData;
            builder.applyOpacityFiltering($scope.selections);

            if (filterActions.displayNoShows != $scope.selections.displayNoShows) {
                filterActions.displayNoShows = $scope.selections.displayNoShows;
                filterActions.filterBook();
            }
        }

        $scope.reset = function () {
            filterActions.includeFilterData = false;
            createDefault();
            builder.applyOpacityFiltering(undefined);
        }

        function createDefault() {
            $scope.selections = {};
            $scope.selections = {
                appointStatusFilter: globals.opacityFilterSelectionsDefaults.appointStatusFilter,
                confirmStatusFilter: globals.opacityFilterSelectionsDefaults.confirmStatusFilter,
                hasNotes: globals.opacityFilterSelectionsDefaults.hasNotes,
                hasClientNotes: globals.opacityFilterSelectionsDefaults.hasClientNotes,
                bookedOnline: globals.opacityFilterSelectionsDefaults.bookedOnline,
                bookedViaBookingAgent: globals.opacityFilterSelectionsDefaults.bookedViaBookingAgent,
                numberOfVisits: globals.opacityFilterSelectionsDefaults.numberOfVisits,
                selectedResource: globals.opacityFilterSelectionsDefaults.selectedResource,
                selectedEquipment: globals.opacityFilterSelectionsDefaults.selectedEquipment,
                selectedApptCategory: globals.opacityFilterSelectionsDefaults.selectedApptCategory,
                isFirstTimeServiceCategoryBooked: globals.opacityFilterSelectionsDefaults.isFirstTimeServiceCategoryBooked,
                isNewClient: globals.opacityFilterSelectionsDefaults.isNewClient,
                isWalkin: globals.opacityFilterSelectionsDefaults.isWalkin,
                isUnassignedEmployee: globals.opacityFilterSelectionsDefaults.isUnassignedEmployee,
                isRebooked: globals.opacityFilterSelectionsDefaults.isRebooked,
                isRepeatClientBusiness: globals.opacityFilterSelectionsDefaults.isRepeatClientBusiness,
                isRepeatClientEmployee: globals.opacityFilterSelectionsDefaults.isRepeatClientEmployee,
                displayNoShows: globals.displayNoShows,
                program: globals.opacityFilterSelectionsDefaults.program,
                bookedViaMyMeevo: globals.opacityFilterSelectionsDefaults.bookedViaMyMeevo,
            }
        }

        function isLoggedInUserMatched(filter: string, displayName: string): boolean {
            let isMatched = (filter.length === 0);
            if (!isMatched) {
                let pattern = filter.replace("_", ".").replace("%", "");
                let re = new RegExp(pattern, "i");
                isMatched = re.test(displayName);
            }
            return isMatched;
        }

        function setLoggedInUser(users, userId) {
            let loggedInUser: Meevo.Model.EmployeeListItem = _.findWhere(users, { id: userId });
            if (loggedInUser && users.length > 1) {
                loggedInUser.applyStyle = "meevo-typeahead-item-bold";
            }
        }

        $scope.employeeUserTypeAheadPreProcessData = function(responseData, requestData): any[] {
            if (requestData.pageNumber == 0) {
                if (isLoggedInUserMatched(requestData.criteria.filter, $scope.currentIdentity.displayName)) {
                    responseData.splice(0, 0, loggedInUser);
                }
                setLoggedInUser(responseData, $scope.currentIdentity.userId);
                return responseData;
            }
        }
    }
]);